import { useContext } from 'react';
import { Dropdown, DropdownOption, TableCell, Typography } from '@vp/swan';
import { ExperimentsContext } from '../../contexts/ExperimentsContext';

interface DebugExperimentsControlsProps {
  experimentKey: string;
  variationKey?: string;
  availableVariationKeys: string[];
}

export const DebugExperimentsControls = ({
  experimentKey,
  variationKey = 'NONE',
  availableVariationKeys,
}: DebugExperimentsControlsProps) => {
  const { overrideExperiment } = useContext(ExperimentsContext) || {
    overrideExperiment: () => {},
  };
  return (
    <>
      <TableCell>
        <Typography fontSize="small">{experimentKey}</Typography>
      </TableCell>
      <TableCell>
        <Dropdown
          value={variationKey}
          onChange={(event) => {
            let selectedVariationKey: string | undefined = event.target.value;
            if (selectedVariationKey === 'NONE') {
              selectedVariationKey = undefined;
            }
            overrideExperiment({
              experimentKey,
              variationKey: selectedVariationKey || '',
              availableVariationKeys,
              shouldFireImpression: false,
            });
          }}
        >
          <DropdownOption value="NONE">None Selected</DropdownOption>
          {availableVariationKeys.map((variation, index) => (
            <DropdownOption value={variation} key={index}>
              {variation}
            </DropdownOption>
          ))}
        </Dropdown>
      </TableCell>
    </>
  );
};
